import styled from 'styled-components';
import {Link} from 'react-router-dom';

export const Container = styled.div`
  &.Wrapper{
    position: relative;
  }
  &.HidenSignOut{
    position: absolute;
    top: 35px;
    right: 0;
    width: 140px;
    background: #FFFFFF;
    border-radius: 4px;
    cursor: pointer;
    z-index: 10;
    text-align: left;
    padding-bottom: 10px;
  }
`;

export const StyledImg = styled.img`
  cursor: pointer;
  &.AvatarIcon{
    width: 34px;
    height: 34px;
    border-radius: 100%;
  }
  &.LargeImg{
    width: 100px;
    height: 100px;
  }
`;

export const StyledInitials = styled.span`
  &.AvatarText{
    padding: 7px 5px 7px 5px;
    background: #999;
    border-radius: 100%;
    font-family: Manrope, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    width: 34px;
    height: 34px;
    cursor: pointer;
  }
  &.LargeImg{
    cursor: default;
    width: 100px;
    height: 100px;
    font-size: 28px;
  }
`;

export const ListItem = styled.div`
  padding-left: 8px;
  &:hover{
    background: #CADFFC;
    text-decoration: underline;
    color: #2C2B48;
  }
`

export const DropItem = styled.div`
  padding: 12px 16px 14px 8px;
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  color: #2C2B48;
  border-bottom: 1px solid rgba(33, 33, 33, 0.08);
`;

export const DropLink = styled(Link)`
  padding: 12px 16px 14px 8px;
  font-family: Manrope, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  color: #2C2B48;
  display: block;
  border-bottom: 1px solid rgba(33, 33, 33, 0.08);
`